import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { EventIndexResource } from "../../../../../shared/types/event";

const baseKey = ["dashboard", "events"];

interface EventWidgetData {
	total: number;
	events: EventIndexResource[];
}
export const eventsWidgetService = {
	get: () => {
		return axios.get<LaravelResponse<EventWidgetData>>(`${keyToUrl(baseKey)}`);
	},
	key: baseKey,
};
